import { render, staticRenderFns } from "./usage.vue?vue&type=template&id=38db6bd6&scoped=true"
import script from "./usage.vue?vue&type=script&lang=js"
export * from "./usage.vue?vue&type=script&lang=js"
import style0 from "./usage.vue?vue&type=style&index=0&id=38db6bd6&prod&lang=scss"
import style1 from "./usage.vue?vue&type=style&index=1&id=38db6bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db6bd6",
  null
  
)

export default component.exports